import { Navigate, Route, Routes } from 'react-router-dom';
import { selectCurrentUser } from '../../../redux/slices/authSlice';
import { useAppSelector } from '../../../hooks/reduxHooks';
import Administracion from '../../../pages/Administracion/Index';
import CargaDocumentos from '../../../pages/CargaDocumentos/Index';
import ConsultaDocumentos from '../../../pages/ConsultaDocumentos/Index';
import NotFound from '../../NotFound';

function RoutesManager() {
    const user = useAppSelector(selectCurrentUser);
    return (
        <Routes>
            <Route path="carga-documentos" element={<CargaDocumentos />} />
            <Route path="consulta-documentos" element={<ConsultaDocumentos />} />
            {user?.esAdmin && <Route path="administracion/*" element={<Administracion />} />}
            <Route path="*" element={<NotFound />} />
            <Route path="/" element={<Navigate to="/app/consulta-documentos" replace />} />
        </Routes>
    );
}

export default RoutesManager;
